export const CAROUSEL_HEIGHT = 1200;

export default {
  CAROUSEL_HEIGHT,
};
